import { t as e } from "./utils-DQJjwn-K.js";
import "react";
import { XIcon as t } from "lucide-react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import * as i from "@radix-ui/react-dialog";
//#region src/components/ui/dialog.tsx
function a({ ...e }) {
	return /* @__PURE__ */ n(i.Root, {
		"data-slot": "dialog",
		...e
	});
}
function o({ ...e }) {
	return /* @__PURE__ */ n(i.Portal, {
		"data-slot": "dialog-portal",
		...e
	});
}
function s({ ...e }) {
	return /* @__PURE__ */ n(i.Close, {
		"data-slot": "dialog-close",
		...e
	});
}
function c({ className: t, ...r }) {
	return /* @__PURE__ */ n(i.Overlay, {
		"data-slot": "dialog-overlay",
		className: e("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", t),
		...r
	});
}
function l({ className: a, children: s, showCloseButton: l = !0, ...u }) {
	return /* @__PURE__ */ r(o, {
		"data-slot": "dialog-portal",
		children: [/* @__PURE__ */ n(c, {}), /* @__PURE__ */ r(i.Content, {
			"data-slot": "dialog-content",
			className: e("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg", a),
			...u,
			children: [s, l && /* @__PURE__ */ r(i.Close, {
				"data-slot": "dialog-close",
				className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
				children: [/* @__PURE__ */ n(t, {}), /* @__PURE__ */ n("span", {
					className: "sr-only",
					children: "Close"
				})]
			})]
		})]
	});
}
function u({ className: t, ...r }) {
	return /* @__PURE__ */ n("div", {
		"data-slot": "dialog-header",
		className: e("flex flex-col gap-2 text-center sm:text-left", t),
		...r
	});
}
function d({ className: t, ...r }) {
	return /* @__PURE__ */ n("div", {
		"data-slot": "dialog-footer",
		className: e("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", t),
		...r
	});
}
function f({ className: t, ...r }) {
	return /* @__PURE__ */ n(i.Title, {
		"data-slot": "dialog-title",
		className: e("text-lg leading-none font-semibold", t),
		...r
	});
}
function p({ className: t, ...r }) {
	return /* @__PURE__ */ n(i.Description, {
		"data-slot": "dialog-description",
		className: e("text-muted-foreground text-sm", t),
		...r
	});
}
//#endregion
export { d as a, p as i, s as n, u as o, l as r, f as s, a as t };

//# sourceMappingURL=dialog-BkE_1yXM.js.map